"use strict";
/*
 * Created on 04 30 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailValuesDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutImpactReportDetailValuesDTOConverter, _DataObjectConverter_);

  function SelloutImpactReportDetailValuesDTOConverter() {
    _classCallCheck(this, SelloutImpactReportDetailValuesDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailValuesDTOConverter).apply(this, arguments));
  }

  return SelloutImpactReportDetailValuesDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutImpactReportDetailValuesDTOConverter = SelloutImpactReportDetailValuesDTOConverter;